"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AriaPopover = AriaPopover;
var React = _interopRequireWildcard(require("react"));
var _overlays = require("@react-aria/overlays");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Minimal implementation of a react-aria compliant popover for use in the date picker. Other applications would
 * prefer the Radix popover*/

function AriaPopover(props) {
  var ref = React.useRef(null);
  var _props$popoverRef = props.popoverRef,
    popoverRef = _props$popoverRef === void 0 ? ref : _props$popoverRef,
    state = props.state,
    children = props.children,
    isNonModal = props.isNonModal,
    offset = props.offset,
    placement = props.placement;
  var _ref = (0, _overlays.usePopover)(_objectSpread({}, props, {
      offset: offset,
      popoverRef: popoverRef,
      placement: placement
    }), state),
    popoverProps = _ref.popoverProps,
    underlayProps = _ref.underlayProps;
  popoverProps = _objectSpread({}, popoverProps, {
    style: _objectSpread({}, popoverProps.style, {
      pointerEvents: 'auto'
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_overlays.Overlay, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, underlayProps)), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread({}, popoverProps, {
      ref: popoverRef,
      children: [!isNonModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_overlays.DismissButton, {
        onDismiss: state.close
      }), children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_overlays.DismissButton, {
        onDismiss: state.close
      })]
    }))]
  });
}